import React, {Component} from 'react';
import {Question, Common} from '../components';

export default class QuestionTemplate extends Component {
    constructor(props) {
        super(props);

        // Click invisible input button
        this.clickImageInput = (id) => {
            const target = document.getElementById(id)
            return target.click()
        };
    }

    render() {
        const postState = this.props.post;
        return (
            <main>
                <Common.Spacer size={"medium"} quantity={2} />

                <section className="c-section">
                    <div className="c-section__wrapin-narrow">
                        <div className="p-grid__input">
                            <Question.TextLabel label="質問内容" isRequired={true} />
                            <Question.InputField id="question" type="text" placeholder="質問を入力" maxLength={32}
                                                 input={this.props.inputText} value={postState.question} />
                        </div>

                        <div className="p-grid__input">
                            <Question.TextLabel label="回答" isRequired={true} />
                            <Question.InputField id="answer_a" type="text" placeholder="回答Aを入力" maxLength={16}
                                                 input={this.props.inputText} value={postState.answer_a} />
                            <Question.InputField id="answer_b" type="text" placeholder="回答Bを入力" maxLength={16}
                                                 input={this.props.inputText} value={postState.answer_b} />
                        </div>

                        <div className="p-grid__input">
                            <Question.TextLabel label="説明" isRequired={false} />
                            <Question.TextArea id="description" rows="5" input={this.props.inputText}
                                               value={postState.description} />
                        </div>

                        <div className="p-grid__input">
                            <Question.TextLabel label="参考リンク" isRequired={false} />
                            <Question.InputField id="url" type="text" placeholder="https://"
                                                 input={this.props.inputText} value={postState.url} />
                        </div>

                        <div className="p-grid__input">
                            <Question.TextLabel label="参考画像" isRequired={false} />
                            <Question.ImageArea id="image" upload={this.clickImageInput}
                                                preview={this.props.uploadImage} delete={this.props.deleteImage}/>
                        </div>

                        <Common.Spacer size={"small"} quantity={1} />

                        <div className="p-grid__row-center">
                            <Common.SquareButton onClick={this.props.cancelPost} text={"キャンセル"} type={"secondary"} />
                            <Question.SubmitButton values={postState} post={this.props.postQuestion}/>
                        </div>
                    </div>
                </section>

                <Common.Spacer size={"medium"} quantity={1} />
            </main>
        )
    }
}